module.exports = __webpack_public_path__ + "img/2f_r_kasuya.64ad105b.png";